module.exports = __webpack_public_path__ + "static/media/Right-Arrow-White.3209f8a9.svg";